import React from 'react'

import '../stylesheets/components/Page.scss'

class Page extends React.Component {
    render() {
        return (
            <div className="Page">
                <div className="Page_header">
                    <p>{this.props.title}</p>
                    {this.props.action && (
                        <button
                            disabled={!this.props.enabled}
                            onClick={this.props.action}
                            style={{ backgroundColor: this.props.button, color: this.props.text }}>
                            {this.props.call}
                        </button>
                    )}
                </div>
                <div className="Page_content">{this.props.children}</div>
                {this.props.loading && (
                    <div className="Page_loader">
                        <div className="Page_spinner">
                            <img src="/images/spinner.svg" alt="" />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default Page
